// Copyright (c) 2023 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {getStore} from '../../../../src/store-factory';
import {oktaToken} from '../../../../src/shared/services/okta';
import {openFile} from '../../../../src/shared/services/open-file';

export const downloadFile = async file => {

    const dispatch = getStore().dispatch;

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const fileName = decodeURI(file.fileName);

        const accessToken = await oktaToken('accessToken');
        const authorizedfetch = (url, authToken) => fetch(url, {
            headers: {
                Authorization: `Bearer ${authToken.accessToken}`
            }
        });

        authorizedfetch(file.source, accessToken)
        .then(response => response.blob())
        .then(blob => {

            openFile(blob, fileName, 'application/octet-stream');

        });

    } catch (error) {

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/file-download.js